import qs from "query-string";

const queryParser = locationSearch => {
  return qs.parse(locationSearch, { ignoreQueryPrefix: true });
};

export default queryParser;
